export const styling = {
  'maple-wj': {
    button: {
      base: 'rounded-full tracking-[.2em] uppercase',
      primary: 'bg-[#017F7C] hover:bg-[#1F4D49]',
      secondary:
        'border bg-white border-[#017F7C] hover:bg-[#E8F2F3] text-[#1F4D49]',
      size: {
        default: '',
        md: 'h-10 py-2 px-4',
        lg: 'h-[3.5rem] w-[13rem]',
      },
    },
  },
  'maple-nab': {
    button: {
      base: 'rounded-md capitalize',
      primary:
        'bg-tenant-primary-color hover:bg-tenant-secondary-color text-white',
      secondary:
        'bg-tenant-primary-color hover:bg-tenant-secondary-color text-white',
      size: {
        default: '',
        md: 'h-10 py-2 px-4',
        lg: 'h-[3.5rem] w-[13rem]',
      },
    },
  },
  'maple-points-at-work': {
    button: {
      base: 'rounded-md capitalize',
      primary:
        'bg-tenant-primary-color hover:bg-tenant-secondary-color text-white',
      secondary:
        'bg-tenant-primary-color hover:bg-tenant-secondary-color text-white',
      size: {
        default: '',
        md: 'h-10 py-2 px-4',
        lg: 'h-[3.5rem] w-[13rem]',
      },
    },
  },
  default: {
    button: {
      base: 'rounded-3xl border border-gray-300',
      primary: '',
      secondary: 'border border-black bg-white text-black',
      size: {
        default: '',
        md: 'h-[3rem] w-[10rem]',
        lg: 'h-[3rem] w-[10rem]',
      },
    },
  },
  bgPrimary: 'background-color-blue-600',
  textPrimary: 'text-blue-600',
  Link: 'cursor-pointer border-b-2 border-transparent hover:border-b-2 hover:border-tenant-primary-color hover:text-tenant-primary-color',
  LinkTwo:
    'cursor-pointer border-b-2 border-transparent hover:border-b-2 hover:border-white text-white',
  button: 'rounded-3xl border border-gray-300',
  box: 'rounded-lg border',
  tag: 'p-3 flex bg-neutral-100 items-center text-sm font-normal rounded-md border border-transparent hover:border-gray-300',
  pagination: {
    Item: 'flex items-center text-base justify-center w-11 h-11 rounded-full leading-tight bg-white hover:bg-neutral-100 text-gray-500 cursor-pointer',
    currentPage:
      'flex items-center text-base justify-center bg-neutral-100 w-11 h-11 rounded-full text-gray-500 hover:bg-default hover:text-default cursor-default',
    ellipsis:
      'flex items-center justify-center px-3 h-8 leading-tight bg-white border border-zinc-200',
    cheveron:
      'flex items-center text-base justify-center w-11 h-11 rounded-full leading-tight bg-white hover:bg-neutral-100 text-gray-500 cursor-pointer',
    disabledPaginationItem:
      'hover:bg-default hover:text-default cursor-default text-gray-500',
    disabledCheveron: 'text-grey-100 opacity-80 cursor-default',
  },
}
